var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAttachment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1986 9.2081L10.5403 16.8664C9.60208 17.8046 8.3296 18.3317 7.00278 18.3317C5.67596 18.3317 4.40348 17.8046 3.46528 16.8664C2.52708 15.9282 2 14.6558 2 13.3289C2 12.0021 2.52708 10.7296 3.46528 9.79144L11.1236 2.1331C11.7491 1.50763 12.5974 1.15625 13.4819 1.15625C14.3665 1.15625 15.2148 1.50763 15.8403 2.1331C16.4657 2.75857 16.8171 3.60689 16.8171 4.49144C16.8171 5.37598 16.4657 6.2243 15.8403 6.84977L8.17361 14.5081C7.86088 14.8208 7.43672 14.9965 6.99445 14.9965C6.55217 14.9965 6.12801 14.8208 5.81528 14.5081C5.50255 14.1954 5.32685 13.7712 5.32685 13.3289C5.32685 12.8867 5.50255 12.4625 5.81528 12.1498L12.8903 5.0831",
    stroke: "#19CEFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttachment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attachment.66f99cdb.svg";
export { ForwardRef as ReactComponent };